import request from '@/utils/request'
export default {
  // 搜索新增修改用户信息
  commonUser(method, data) {
    return request({
      url: '/system/commonUser',
      method: method,
      data
    })
  },
  // 获取列表
  getCommonUser(params) {
    return request({
      url:'/system/commonUser',
      method:'get',
      params
    })
  },
  // 获取或删除用户信息
  findOrDelCommonUser(method,id) {
    return request({
      url: `/system/commonUser/${id}`,
      method
    })
  },

  // 导出用户信息列表
  exportCommonUser() {
    return process.env.VUE_APP_BASE_API + '/system/commonUser/export'
  },

  // 导入用户rtx
  importExcelCommonUser(data) {
    return request({
      url:'/system/commonUser/importExcel',
      method:'post',
      data
    })
  }
}
